import React from "react";
import "./VidLoader.scss";

const VidLoader = () => {
    return (
        <div className="vid-loader-overlay">
            <div className="loader">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
        </div>
    );
};

export default VidLoader;
